
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/contentpage",
      function () {
        return require("private-next-pages/contentpage.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/contentpage"])
      });
    }
  